import SegmentSerializer from 'cio/serializers/segment';

export default SegmentSerializer.extend({
  normalizeResponse(store, type, payload, id, requestType) {
    payload.customer_segments = payload.segments;

    delete payload.segments;

    return this._super(store, type, payload, id, requestType);
  },
});
